export const gu = {
  common: {
    save: "સેવ કરો",
    cancel: "રદ કરો",
    delete: "ડીલીટ કરો",
    edit: "એડિટ કરો",
    view: "જુઓ",
    close: "બંધ કરો",
    apply: "લાગુ કરો",
    clear: "ક્લિયર કરો",
    search: "શોધો",
    filter: "ફિલ્ટર",
    showFilter: "ફિલ્ટર બતાવો",
    hideFilter: "ફિલ્ટર છુપાવો",
    applyFilter: "ફિલ્ટર લાગુ કરો",
    clearFilter: "ક્લિયર",
    loading: "લોડ થઈ રહ્યું છે...",
    saving: "સેવ થઇ રહ્યું છે...",
    pleaseWait: "કૃપા કરી રાહ જુઓ...",
    somethingWentWrong: "કંઈક ખોટું થયું છે. કૃપા કરી ફરી પ્રયાસ કરો.",
    confirm: "પુષ્ટિ કરો",
    yes: "હા",
    no: "ના",
    ok: "બરાબર",
    back: "પાછા",
    goBack: "પાછા જાઓ",
    noRecords: "કોઈ રેકોર્ડ મળ્યો નથી",
    actions: "ક્રિયાઓ",
    srNo: "#",
    date: "તારીખ",
    fromDate: "તારીખ થી",
    toDate: "તારીખ સુધી",
    add: "ઉમેરો",
    remove: "હટાવો",
    inProgress: "પ્રક્રિયામાં",
    completed: "પૂર્ણ",
    downloadPdf: "PDF ડાઉનલોડ કરો",
    update: "અપડેટ કરો",
    submit: "સબમિટ કરો",
    continue: "આગળ વધો",
    name: "નામ",
    notes: "નોંધ",
    note: "નોંધ",
    status: "સ્થિતિ",
    amount: "રકમ",
    rate: "રેટ",
    quantity: "જથ્થો",
    selectDate: "તારીખ પસંદ કરો",
    home: "હોમ",
    perPage: "પ્રતિ પૃષ્ઠ",
    sortBy: "ક્રમ",
    ascending: "ચડતો ક્રમ",
    descending: "ઉતરતો ક્રમ",
    exportReport: "રિપોર્ટ એક્સપોર્ટ કરો",
    generateReport: "રિપોર્ટ બનાવો",
    print: "પ્રિન્ટ",
    create: "બનાવો",
    saved: "સેવ થઇ ગયું",
    saveChanges: "ફેરફારો સેવ કરો",
    open: "ખોલો",
    refresh: "રિફ્રેશ",
    select: "પસંદ કરો",
    none: "કોઈ નથી",
    total: "કુલ",
    required: "જરૂરી",
    previous: "પાછલું",
    next: "આગળનું",
    reportFileNotAvailable: "રિપોર્ટ ફાઇલ ઉપલબ્ધ નથી.",
  },
  login: {
    title: "લોગિન કરો",
    subtitle: "તમારા ખાતામાં પ્રવેશ કરવા માટે તમારી વિગતો દાખલ કરો",
    erpSystem: "Hardware ERP System",
    mobileLabel: "મોબાઇલ નંબર",
    mobilePlaceholder: "તમારો મોબાઇલ નંબર દાખલ કરો",
    mobileRequired: "મોબાઇલ નંબર આવશ્યક છે",
    passwordLabel: "પાસવર્ડ",
    passwordPlaceholder: "તમારો પાસવર્ડ દાખલ કરો",
    passwordRequired: "પાસવર્ડ આવશ્યક છે",
    forgotPassword: "પાસવર્ડ ભૂલી ગયા?",
    forgotPasswordTooltip: "કૃપા કરી ને એડમીન નો કોંટેક્ટ કરો.",
    loginButton: "લોગિન કરો",
    loggingIn: "લોગિન થઈ રહ્યું છે...",
    copyright: "બધા અધિકારો સુરક્ષિત.",
    tagline: "તમારા વ્યવસાયને વ્યવસ્થિત અને કાર્યક્ષમ બનાવવા માટેનું આધુનિક અને સંપૂર્ણ સમાધાન",
    feature1Title: "સુરક્ષિત અને વિશ્વસનીય",
    feature1Desc: "તમારો ડેટા સંપૂર્ણ સુરક્ષિત",
    feature2Title: "રીઅલ-ટાઇમ ટ્રેકિંગ",
    feature2Desc: "તાત્કાલિક અપડેટ અને રિપોર્ટ",
  },
  branch: {
    modalTitle: "શાખા પસંદ કરો",
    modalDescription: "કૃપા કરીને તમારી કામ કરવાની શાખા પસંદ કરો",
    selectPlaceholder: "શાખા પસંદ કરો...",
    confirmButton: "પુષ્ટિ કરો",
    dropdownLabel: "શાખા પસંદ કરો",
    selectBranch: "શાખા પસંદ કરો",
  },
  profile: {
    pageTitle: "પ્રોફાઇલ સેટિંગ્સ",
    breadcrumbHome: "હોમ",
    userProfileTitle: "વપરાશકર્તા પ્રોફાઇલ",
    userProfileSubtitle: "તમારી વ્યક્તિગત માહિતી અપડેટ કરો",
    changePasswordTitle: "પાસવર્ડ બદલો",
    changePasswordSubtitle: "તમારા પાસવર્ડને અપડેટ કરો.",
    nameLabel: "યુઝરનેમ",
    namePlaceholder: "તમારું યુઝરનેમ દાખલ કરો",
    nameRequired: "નામ આવશ્યક છે",
    emailLabel: "ઇમેઇલ",
    emailPlaceholder: "તમારું ઇમેઇલ દાખલ કરો",
    emailRequired: "ઇમેઇલ આવશ્યક છે",
    phoneLabel: "મોબાઇલ નંબર",
    updateProfileButton: "ફેરફારો સાચવો",
    updatingProfile: "સાચવી રહ્યું છે...",
    oldPasswordLabel: "જૂનો પાસવર્ડ",
    oldPasswordPlaceholder: "તમારો જૂનો પાસવર્ડ દાખલ કરો",
    oldPasswordRequired: "જૂનો પાસવર્ડ આવશ્યક છે",
    newPasswordLabel: "નવો પાસવર્ડ",
    newPasswordPlaceholder: "તમારો નવો પાસવર્ડ દાખલ કરો",
    newPasswordRequired: "નવો પાસવર્ડ આવશ્યક છે",
    newPasswordMin: "પાસવર્ડ ઓછામાં ઓછો 8 અક્ષરનો હોવો જોઈએ",
    confirmPasswordLabel: "પાસવર્ડ કન્ફર્મ કરો",
    confirmPasswordPlaceholder: "તમારો નવો પાસવર્ડ ફરીથી દાખલ કરો",
    confirmPasswordRequired: "કૃપા કરીને નવા પાસવર્ડની પુષ્ટિ કરો",
    confirmPasswordMatch: "પાસવર્ડ મેળ ખાતા નથી",
    changePasswordButton: "પાસવર્ડ બદલો",
    changingPassword: "બદલાઈ રહ્યો છે...",
  },
  settings: {
    pageTitle: "રિપોર્ટ સેટિંગ્સ",
    breadcrumbHome: "હોમ",
    companyInfoTitle: "કંપનીની માહિતી",
    companyInfoSubtitle: "PDF રિપોર્ટ હેડરમાં વપરાય છે",
    addressTitle: "સરનામું",
    addressSubtitle: "દરેક રિપોર્ટ પર છપાતું સરનામું",
    contactsTitle: "સંપર્કો",
    contactsSubtitle: "માલિકના નામ અને ફોન નંબરો",
    companyNameLabel: "કંપનીનું નામ",
    companyNamePlaceholder: "બેઝિક રિપોર્ટ પર બતાવાતું નામ",
    companyNameReportLabel: "કંપનીનું નામ (રિપોર્ટ હેડર)",
    companyNameReportPlaceholder: "વિગતવાર રિપોર્ટ હેડર માટેનું નામ",
    companyTaglineReportLabel: "ટેગલાઇન",
    companyTaglineReportPlaceholder: "રિપોર્ટ હેડર ઉપર બતાવાતી ટેગલાઇન",
    companyAddress1Label: "સરનામું લાઇન ૧",
    companyAddress1Placeholder: "શેરીનું સરનામું",
    companyAddress2Label: "સરનામું લાઇન ૨",
    companyAddress2Placeholder: "શહેર, પિન કોડ",
    companyOwner1Label: "માલિક ૧ નું નામ",
    companyOwner1Placeholder: "મુખ્ય માલિકનું નામ",
    companyOwnerPhone1Label: "માલિક ૧ નો ફોન",
    companyOwnerPhone1Placeholder: "મુખ્ય માલિકનો ફોન",
    companyOwner2Label: "માલિક ૨ નું નામ",
    companyOwner2Placeholder: "બીજા માલિકનું નામ",
    companyOwnerPhone2Label: "માલિક ૨ નો ફોન",
    companyOwnerPhone2Placeholder: "બીજા માલિકનો ફોન",
    saveButton: "સેટિંગ્સ સાચવો",
    saving: "સાચવી રહ્યું છે...",
  },
  dashboard: {
    pageTitle: "ડેશબોર્ડ",
    dailyUsageTitle: "દૈનિક ઉપયોગ મોડ્યુલ",
    stockManagementTitle: "સ્ટોક વ્યવસ્થાપન",
    masterTitle: "માસ્ટર મોડ્યુલ",
    openButton: "ખોલો",
    parties: { title: "પાર્ટી", description: "પાર્ટીની વિગતો મેનેજ કરો", buttonLabel: "પાર્ટી" },
    accountTypes: { title: "ખાતા પ્રકાર", description: "ખાતા પ્રકાર કેટેગરી મેનેજ કરો", buttonLabel: "ખાતા પ્રકાર" },
    accounts: { title: "ખાતા", description: "નાણાકીય ખાતા મેનેજ કરો", buttonLabel: "ખાતા" },
    accountManagement: { title: "ખાતા વ્યવસ્થાપન", description: "ખાતા પ્રકાર અને ખાતા મેનેજ કરો", buttonLabel: "ખાતા પ્રકાર", secondaryButtonLabel: "ખાતા" },
    items: { title: "આઇટમ", description: "આઇટમ માસ્ટર ડેટા મેનેજ કરો" },
    processes: { title: "સબ પ્રોસેસ", description: "પ્રોસેસ હેઠળના સબ પ્રોસેસ વેરિઅન્ટ મેનેજ કરો (દા.ત. બફિંગ/પ્લેટિંગના સબ પ્રકાર)" },
    processDefinitions: { title: "પ્રોસેસ", description: "ઓર્ડર, રિસીવ અને સ્ટોક ચલાવતી મેન્યુફેક્ચરિંગ પ્રોસેસ મેનેજ કરો" },
    materials: { title: "મટીરીયલ", description: "મટીરીયલ માસ્ટર ડેટા મેનેજ કરો, તેની સાઈઝ સહિત" },
    itemSizes: { title: "આઇટમ સાઈઝ", description: "આઇટમ સાઈઝ માસ્ટર ડેટા મેનેજ કરો" },
    users: { title: "યુઝર્સ", description: "યુઝર્સ અને પરમિશનનું સંચાલન કરો" },
    stockSizes: { title: "મટીરીયલ સ્ટોક", description: "મટીરીયલ પ્રમાણે સ્ટોક જુઓ", buttonLabel: "ખોલો" },
    stockPieces: { title: "પાઇપ પીસ સ્ટોક", description: "મટિરિયલ સાઈઝ પ્રમાણે સેવ થયેલા પાઇપ પીસ જુઓ", buttonLabel: "ખોલો" },
    processItemsStock: { title: "પ્રોસેસ આઇટમ સ્ટોક", description: "પ્રોસેસ પ્રમાણે ઓર્ડર/મળેલ/ઉપલબ્ધ સ્ટોક જુઓ", buttonLabel: "ખોલો" },
    processPartyStock: { title: "પ્રોસેસ પાર્ટી સ્ટોક", description: "પ્રોસેસ પ્રમાણે પાર્ટી પાસે પેન્ડિંગ સ્ટોક જુઓ", buttonLabel: "ખોલો" },
    activityLogs: { title: "પ્રવૃત્તિ લૉગ્સ", description: "સિસ્ટમ ઓડિટ ટ્રેલ જુઓ", buttonLabel: "જુઓ" },
    processModuleDescription: "{name} ઓર્ડર અને રિસીવ મેનેજ કરો",
    processOrderButtonLabel: "ઓર્ડર",
    processReceiveButtonLabel: "રીસીવ",
  },
  layout: {
    manageProfile: "પ્રોફાઇલ મેનેજ કરો",
    settings: "સેટિંગ્સ",
    activityLogs: "પ્રવૃત્તિ લૉગ્સ",
    devFeedback: "ડેવ ફીડબેક",
    logout: "લોગઆઉટ",
    selectBranchLabel: "શાખા પસંદ કરો",
  },
  imageUpload: {
    imageAlt: "આઇટમ",
    changeImage: "ઈમેજ બદલો",
    dropOrBrowse: "ઈમેજ અહીં મૂકો અથવા બ્રાઉઝ કરવા ક્લિક કરો",
    formatHint: "JPG, PNG, GIF, WEBP",
    cropTitle: "ઈમેજ ક્રોપ કરો",
    cropDescription: "સ્થાન બદલવા ખેંચો. ઝૂમ માટે પિંચ કરો અથવા સ્લાઇડરનો ઉપયોગ કરો.",
    applyCrop: "ક્રોપ લાગુ કરો",
  },
  users: {
    pageTitle: "યુઝર મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbUsers: "યુઝર્સ",
    breadcrumbCreate: "યુઝર બનાવો",
    breadcrumbEdit: "યુઝર સુધારો",
    addNewUser: "નવો યુઝર ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "ID, નામ, ઈમેલ અથવા ફોન નંબર શોધો...",
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "યૂઝરનું આઈડી",
      name: "યૂઝરનું નામ",
      email: "ઈમેલ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "યૂઝરને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "યૂઝરની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      user: "યુઝર",
      phone: "ફોન નંબર",
      email: "ઇમેઇલ",
      role: "રોલ",
      permissions: "પરવાનગીઓ",
      created: "બનાવ્યું",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ યુઝર મળ્યો નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "યુઝર્સ",
    formTitle: "યુઝર માહિતી",
    nameLabel: "નામ",
    namePlaceholder: "યુઝરનું નામ દાખલ કરો",
    nameRequired: "નામ આવશ્યક છે",
    phoneLabel: "ફોન",
    phonePlaceholder: "ફોન નંબર દાખલ કરો",
    phoneRequired: "ફોન આવશ્યક છે",
    emailLabel: "ઇમેઇલ",
    emailPlaceholder: "ઇમેઇલ દાખલ કરો",
    emailRequired: "ઇમેઇલ આવશ્યક છે",
    passwordLabel: "પાસવર્ડ",
    passwordPlaceholder: "પાસવર્ડ દાખલ કરો",
    passwordRequired: "પાસવર્ડ આવશ્યક છે",
    confirmPasswordLabel: "પાસવર્ડ કન્ફર્મ કરો",
    confirmPasswordPlaceholder: "પાસવર્ડ ફરીથી દાખલ કરો",
    confirmPasswordRequired: "કૃપા કરીને પાસવર્ડની પુષ્ટિ કરો",
    confirmPasswordMatch: "પાસવર્ડ મેળ ખાતા નથી",
    addressLabel: "સરનામું",
    addressPlaceholder: "સરનામું દાખલ કરો",
    branchPermissions: "શાખા પરવાનગીઓ",
    roleLabel: "ભૂમિકા",
    rolePlaceholder: "ભૂમિકા પસંદ કરો...",
    permissionsLabel: "પરવાનગીઓ",
    selectAll: "બધા પસંદ કરો",
    defaultPermission: "ડિફોલ્ટ",
    saveButton: "યુઝર સાચવો",
    saving: "સાચવી રહ્યું છે...",
    updateButton: "યુઝર અપડેટ કરો",
    updating: "અપડેટ થઈ રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    selectAllModule: "આ મોડ્યુલની બધી પરમિશન",
    permissionsSelected: "પરમિશન",
    creating: "બનાવી રહ્યા છીએ...",
    createButton: "યુઝર બનાવો",
  },
  items: {
    pageTitle: "આઇટમ મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbItems: "આઇટમ",
    addNewItem: "નવી આઇટમ ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "આઇટમ નામ દ્વારા શોધો...",
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "આઇટમ ID",
      name: "આઇટમ નામ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "આઇટમને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "આઇટમની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      image: "ઈમેજ",
      itemName: "આઇટમ નામ",
      material: "મટીરીયલ",
      description: "વર્ણન",
      status: "સ્ટેટસ",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ આઇટમ મળી નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "આઇટમ",
    formTitle: "આઇટમ માહિતી",
    nameLabel: "આઇટમ નામ",
    namePlaceholder: "આઇટમ નામ દાખલ કરો",
    nameRequired: "આઇટમ નામ આવશ્યક છે",
    materialLabel: "મટીરીયલ",
    materialPlaceholder: "મટીરીયલ પસંદ કરો",
    materialSizeLabel: "મટીરીયલ સાઈઝ",
    materialSizePlaceholder: "મટીરીયલ સાઈઝ પસંદ કરો",
    selectMaterialFirst: "પહેલા મટીરીયલ પસંદ કરો",
    descriptionLabel: "વર્ણન",
    descriptionPlaceholder: "આઇટમ વર્ણન દાખલ કરો",
    imageLabel: "આઇટમ ફોટો",
    inInchLabel: "ઇંચ સ્ટેટસ",
    inInchPlaceholder: "ઇંચ સ્ટેટસ પસંદ કરો",
    inInchYes: "ઇંચમાં",
    inInchNo: "ઇંચમાં નથી",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    inUseError: "આઇટમ વપરાશમાં છે, હટાવી શકાતું નથી. કૃપા કરીને પહેલા સંબંધિત રેકોર્ડ્સ દૂર કરો.",
  },
  materials: {
    pageTitle: "મટીરીયલ મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbMaterials: "મટીરીયલ",
    addNewMaterial: "નવું મટીરીયલ ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "મટીરીયલ નામ દ્વારા શોધો...",
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "મટીરીયલ ID",
      name: "મટીરીયલ નામ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "મટીરીયલને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "મટીરીયલની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      name: "મટીરીયલ નામ",
      description: "વર્ણન",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ મટીરીયલ મળ્યું નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "મટીરીયલ",
    formTitle: "મટીરીયલ માહિતી",
    addNewMaterialShort: "મટીરીયલ ઉમેરો",
    nameLabel: "મટીરીયલ નામ",
    namePlaceholder: "મટીરીયલ નામ દાખલ કરો",
    nameRequired: "મટીરીયલ નામ આવશ્યક છે",
    descriptionLabel: "વર્ણન",
    descriptionPlaceholder: "વર્ણન દાખલ કરો",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    inUseError: "મટીરીયલ વપરાશમાં છે, હટાવી શકાતું નથી. કૃપા કરીને પહેલા સંબંધિત રેકોર્ડ્સ દૂર કરો.",
    sizesLabel: "મટીરીયલ સાઈઝ",
    sizeLabel: "સાઈઝ",
    sizeNumber: "સાઈઝ {n}",
    addSizeButton: "સાઈઝ ઉમેરો",
    removeSize: "કાઢી નાખો",
    sizePlaceholder: "સાઇઝ દાખલ કરો (દા.ત. 12.5)",
    sizeRequired: "કૃપા કરીને સાઇઝ દાખલ કરો.",
    sizePatternError: "ફક્ત સંખ્યાત્મક મૂલ્યો, વધુમાં વધુ 1 દશાંશ સ્થાન સાથે માન્ય છે",
    sizeDescriptionPlaceholder: "સાઈઝ વર્ણન દાખલ કરો",
    defaultLabel: "ડિફોલ્ટ",
    defaultHint: "જ્યારે આ મટીરીયલ બીજે ક્યાંય પસંદ થાય અને હજુ કોઈ સાઈઝ પસંદ ન થઈ હોય ત્યારે વપરાય છે.",
    sizesRequired: "કૃપા કરીને ઓછામાં ઓછી એક મટીરીયલ સાઈઝ ઉમેરો.",
  },
  itemSizes: {
    pageTitle: "આઇટમ સાઈઝ મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbItemSizes: "આઇટમ સાઈઝ",
    addNewItemSize: "નવી આઇટમ સાઈઝ ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "આઇટમ સાઈઝ દ્વારા શોધો...",
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "આઇટમ સાઈઝ ID",
      size: "સાઈઝ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "આઇટમ સાઈઝને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "આઇટમ સાઈઝની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      itemSize: "સાઈઝ",
      description: "વર્ણન",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ આઇટમ સાઈઝ મળી નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "આઇટમ સાઈઝ",
    formTitle: "આઇટમ સાઈઝ માહિતી",
    sizeLabel: "સાઈઝ",
    sizePlaceholder: "સાઈઝ દાખલ કરો (દા.ત. 12.5)",
    sizeRequired: "સાઈઝ આવશ્યક છે",
    sizePatternError: "ફક્ત 1 દશાંશ સ્થાન સુધીના આંકડાકીય મૂલ્યો માન્ય છે",
    descriptionLabel: "વર્ણન",
    descriptionPlaceholder: "આઇટમ સાઈઝ વર્ણન દાખલ કરો",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    inUseError: "આઇટમ સાઈઝ વપરાશમાં છે, હટાવી શકાતું નથી. કૃપા કરીને પહેલા સંબંધિત રેકોર્ડ્સ દૂર કરો.",
  },
  activityLogs: {
    pageTitle: "પ્રવૃત્તિ લૉગ્સ",
    breadcrumbHome: "હોમ",
    breadcrumbActivityLogs: "પ્રવૃત્તિ લૉગ્સ",
    searchPlaceholder: "વર્ણન, મોડ્યુલ, IP માં શોધો...",
    searchButton: "શોધો",
    filterToggle: "ફિલ્ટર્સ",
    filterModule: "મોડ્યુલ",
    filterEvent: "ઇવેન્ટ",
    filterUser: "વપરાશકર્તા",
    filterFromDate: "ક્યારથી",
    filterToDate: "ક્યાં સુધી",
    allModules: "બધા મોડ્યુલ",
    allEvents: "બધા ઇવેન્ટ્સ",
    allUsers: "બધા વપરાશકર્તાઓ",
    filterTitle: "ફિલ્ટર્સ",
    searchLabel: "શોધો",
    applyFilters: "ફિલ્ટર્સ લાગુ કરો",
    clearFilters: "ફિલ્ટર્સ સાફ કરો",
    eventCreated: "બનાવ્યું",
    eventUpdated: "અપડેટ કર્યું",
    eventDeleted: "કાઢી નાખ્યું",
    modules: {
      Account: "એકાઉન્ટ",
      AccountType: "એકાઉન્ટ ટાઈપ",
      BranchSetting: "સેટિંગ્સ",
      Items: "આઇટમ",
      ItemSize: "આઇટમ સાઈઝ",
      Parties: "પાર્ટી",
      PartiesItems: "પાર્ટી આઇટમ",
      Payments: "પાર્ટી એકાઉન્ટ",
      ProcessOrder: "પ્રોસેસ ઓર્ડર",
      ProcessReceive: "પ્રોસેસ રિસીવ",
      Processes: "પ્રોસેસ",
      Sizes: "સાઈઝ",
      User: "યુઝર",
    },
    colSr: "ક્રમ",
    colTimestamp: "સમય",
    colUser: "વપરાશકર્તા",
    colBranch: "બ્રાન્ચ",
    colModule: "મોડ્યુલ",
    colEvent: "ઇવેન્ટ",
    colRecordId: "રેકોર્ડ ID",
    colActions: "ક્રિયાઓ",
    viewButton: "જુઓ",
    noRecords: "કોઈ પ્રવૃત્તિ લૉગ મળ્યો નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પૃષ્ઠ:",
    totalLabel: "કુલ",
    systemUser: "સિસ્ટમ",
    modalTitle: "પ્રવૃત્તિ વિગત",
    metaModule: "મોડ્યુલ",
    metaEvent: "ઇવેન્ટ",
    metaUser: "વપરાશકર્તા",
    metaBranch: "બ્રાન્ચ",
    metaTimestamp: "સમય",
    metaIp: "IP સરનામું",
    fieldChanges: "ક્ષેત્ર ફેરફારો",
    field: "ક્ષેત્ર",
    oldValue: "જૂનું મૂલ્ય",
    newValue: "નવું મૂલ્ય",
    noFieldData: "કોઈ ક્ષેત્ર ડેટા કેપ્ચર થયો નથી.",
    closeButton: "બંધ કરો",
  },
  devFeedback: {
    hintBadge: "ફીડબેક મોડ — ગમે ત્યાં ટ્રિપલ-ક્લિક કરો",
    captureTitle: "ફીડબેક આપો",
    captureDescription: "સ્ક્રીનના આ ભાગમાં શું ખોટું છે અથવા શું સારું થઈ શકે તે જણાવો.",
    metaPage: "પેજ",
    metaComponent: "કમ્પોનન્ટ",
    metaElement: "એલિમેન્ટ",
    severityLabel: "પ્રકાર",
    severityBug: "બગ",
    severityUi: "UI સમસ્યા",
    severitySuggestion: "સૂચન",
    severityOther: "અન્ય",
    messageLabel: "ફીડબેક",
    messagePlaceholder: "સમસ્યા અથવા સૂચન વર્ણવો...",
    messageRequired: "ફીડબેક મેસેજ જરૂરી છે",
    cancelButton: "રદ કરો",
    submitButton: "ફીડબેક સબમિટ કરો",
    submitting: "સબમિટ થઈ રહ્યું છે...",
    submitSuccess: "ફીડબેક સફળતાપૂર્વક સબમિટ થયો.",
    submitError: "ફીડબેક સબમિટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    overlayShowButton: "આ પેજ પર ફીડબેક નોંધ બતાવો",
    overlayHideButton: "ફીડબેક નોંધ છુપાવો",
    overlayNoRecords: "આ પેજ પર કોઈ ખુલ્લો ફીડબેક નથી",

    pageTitle: "ડેવ ફીડબેક",
    breadcrumbHome: "હોમ",
    breadcrumbDevFeedback: "ડેવ ફીડબેક",
    filterToggle: "ફિલ્ટર",
    filterTitle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "મેસેજ, પેજ, કમ્પોનન્ટ શોધો...",
    filterStatus: "સ્થિતિ",
    filterSeverity: "પ્રકાર",
    filterFromDate: "તારીખથી",
    filterToDate: "તારીખ સુધી",
    allStatuses: "બધી સ્થિતિ",
    allSeverities: "બધા પ્રકાર",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    statusOpen: "ખુલ્લું",
    statusInProgress: "પ્રગતિમાં",
    statusResolved: "ઉકેલાયું",
    statusClosed: "બંધ",
    colSr: "#",
    colTimestamp: "સમય",
    colUser: "યુઝર",
    colPage: "પેજ",
    colComponent: "કમ્પોનન્ટ",
    colType: "પ્રકાર",
    colStatus: "સ્થિતિ",
    colActions: "ક્રિયાઓ",
    viewButton: "જુઓ",
    deleteButton: "ડિલીટ કરો",
    noRecords: "હજુ સુધી કોઈ ફીડબેક કેપ્ચર થયો નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    systemUser: "અજ્ઞાત",
    modalTitle: "ફીડબેકની વિગત",
    metaUser: "રિપોર્ટ કરનાર",
    metaTimestamp: "રિપોર્ટ સમય",
    metaUrl: "URL",
    metaSelector: "એલિમેન્ટ સિલેક્ટર",
    metaElementText: "એલિમેન્ટ ટેક્સ્ટ",
    metaViewport: "વ્યુપોર્ટ",
    metaBrowser: "બ્રાઉઝર",
    metaIp: "IP એડ્રેસ",
    messageSectionTitle: "ફીડબેક મેસેજ",
    statusSectionTitle: "સમીક્ષા",
    statusLabel: "સ્થિતિ",
    resolutionNoteLabel: "ઉકેલની નોંધ",
    resolutionNotePlaceholder: "અન્ય ડેવલપર્સ માટે નોંધ ઉમેરો (વૈકલ્પિક)...",
    saveButton: "સેવ કરો",
    saving: "સેવ થઈ રહ્યું છે...",
    updateSuccess: "ફીડબેક સફળતાપૂર્વક અપડેટ થયો.",
    updateError: "ફીડબેક અપડેટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    deleteConfirmTitle: "ફીડબેક ડિલીટ કરવો છે?",
    deleteConfirmMessage: "આ ફીડબેક એન્ટ્રી કાયમ માટે ડિલીટ થઈ જશે.",
    deleteConfirmButton: "ડિલીટ કરો",
    deleteSuccess: "ફીડબેક સફળતાપૂર્વક ડિલીટ થયો.",
    deleteError: "ફીડબેક ડિલીટ કરવામાં નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    closeButton: "બંધ કરો",
  },
  parties: {
    pageTitle: "પાર્ટી મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbParties: "પાર્ટી",
    addNewParty: "નવી પાર્ટી ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "ફર્મ નામ, પાર્ટી નામ, ફોન દ્વારા શોધો...",
    typeLabel: "પ્રકાર",
    typePlaceholder: "પ્રકાર પસંદ કરો",
    typeRequired: "કૃપા કરીને ઓછામાં ઓછો એક પ્રકાર પસંદ કરો",
    allTypes: "બધા પ્રકાર",
    ratesCountLabel: "દર પંક્તિઓ",
    types: {
      purchase: "કાસ્ટિંગ",
      cutting: "કટીંગ",
      turning: "ટર્નિંગ",
      buff: "બફ",
      colorProcess: "કલર પ્રોસેસ",
    },
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "પાર્ટી ID",
      firm_name: "ફર્મ નામ",
      name: "પાર્ટી નામ",
      type: "પ્રકાર",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "પાર્ટીને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "પાર્ટીની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      firmName: "ફર્મ નામ",
      partyName: "પાર્ટી નામ",
      type: "પ્રકાર",
      phone: "ફોન",
      items: "આઇટમ",
      pendingPayment: "બાકી ચૂકવણી",
      receivedPayment: "મળેલ ચૂકવણી",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ પાર્ટી મળી નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "પાર્ટી",
    pendingPaymentLabel: "બાકી ચૂકવણી",
    receivedPaymentLabel: "મળેલ ચૂકવણી",
    formTitle: "પાર્ટી માહિતી",
    firmNameLabel: "ફર્મ નામ",
    firmNamePlaceholder: "ફર્મ નામ દાખલ કરો",
    firmNameRequired: "ફર્મ નામ આવશ્યક છે",
    nameLabel: "પાર્ટી નામ",
    namePlaceholder: "પાર્ટી નામ દાખલ કરો",
    phoneLabel: "ફોન",
    phonePlaceholder: "ફોન નંબર દાખલ કરો",
    wpPhoneLabel: "WhatsApp નંબર",
    wpPhonePlaceholder: "WhatsApp નંબર દાખલ કરો",
    addressLabel: "સરનામું",
    addressPlaceholder: "પાર્ટી સરનામું દાખલ કરો",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    inUseError: "પાર્ટી વપરાશમાં છે, હટાવી શકાતું નથી. કૃપા કરીને પહેલા સંબંધિત રેકોર્ડ્સ દૂર કરો.",
    paymentAction: "ચૂકવણી",
    itemsAction: "આઇટમ",
    editAction: "સુધારો",
    deleteAction: "કાઢી નાખો",
    viewAction: "વિગતો જુઓ",
    itemForm: {
      title: "આઇટમ માહિતી",
      itemLabel: "આઇટમ",
      processLabel: "પ્રોસેસ",
      noItemsMessage: "કોઈ આઇટમ મળી નથી. નવી ઉમેરવા Add Item બટન પર ક્લિક કરો.",
      noProcessesMessage: "કોઈ પ્રોસેસ મળી નથી. નવી ઉમેરવા Add Process બટન પર ક્લિક કરો.",
      enterItemName: "આઇટમનું નામ દાખલ કરો",
      selectItemName: "આઇટમનું નામ પસંદ કરો",
      enterProcessName: "પ્રોસેસનું નામ દાખલ કરો",
      selectProcessName: "પ્રોસેસનું નામ પસંદ કરો",
      enterProcessRate: "પ્રોસેસનો રેટ દાખલ કરો",
      enterWeightRate: "વજન પ્રમાણે ભાવ",
      enterWeightRateRequired: "વજન પ્રમાણે ભાવ દાખલ કરો",
      enterPieceRate: "નંગ પ્રમાણે ભાવ",
      enterPieceRateRequired: "નંગ પ્રમાણે ભાવ દાખલ કરો",
      addItem: "આઇટમ ઉમેરો",
      addProcess: "પ્રોસેસ ઉમેરો",
    },
  },
  processes: {
    pageTitle: "સબ પ્રોસેસ મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbProcesses: "સબ પ્રોસેસ",
    addNewProcess: "નવી સબ પ્રોસેસ ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "સબ પ્રોસેસ નામ દ્વારા શોધો...",
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "સબ પ્રોસેસ ID",
      name: "સબ પ્રોસેસ નામ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    typeFilterLabel: "પ્રકાર",
    typeFilterPlaceholder: "પ્રકાર પસંદ કરો",
    sortByPlaceholder: "સબ પ્રોસેસને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "સબ પ્રોસેસની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      processName: "સબ પ્રોસેસ નામ",
      type: "પ્રકાર",
      description: "વર્ણન",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ સબ પ્રોસેસ મળી નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "સબ પ્રોસેસ",
    formTitle: "સબ પ્રોસેસ માહિતી",
    nameLabel: "સબ પ્રોસેસ નામ",
    namePlaceholder: "સબ પ્રોસેસ નામ દાખલ કરો",
    nameRequired: "સબ પ્રોસેસ નામ આવશ્યક છે",
    typeLabel: "પ્રકાર",
    typePlaceholder: "પ્રકાર પસંદ કરો",
    typeRequired: "પ્રકાર આવશ્યક છે",
    modePolicyLabel: "મોડ પોલિસી",
    modePolicyPlaceholder: "પ્રોસેસમાંથી વારસામાં મેળવો",
    modePolicyInHouse: "ફક્ત ઇન-હાઉસ",
    modePolicyOutsource: "ફક્ત આઉટસોર્સ",
    modePolicyBoth: "બંને (ડિફોલ્ટ ઇન-હાઉસ)",
    modePolicyInheritHint: "પ્રોસેસની પોતાની મોડ પોલિસી અનુસરવા ખાલી રાખો.",
    nextProcessLabel: "આગળ મોકલો",
    nextProcessPlaceholder: "માન્ય આગળની પ્રોસેસ પસંદ કરો",
    nextProcessInheritHint: "પ્રોસેસની પોતાની યાદી અનુસરવા ખાલી રાખો.",
    nextProcessMandatoryLabel: "આગળ મોકલો ફરજિયાત",
    nextProcessMandatoryPlaceholder: "પ્રોસેસમાંથી વારસામાં મેળવો",
    nextProcessMandatoryInherit: "પ્રોસેસમાંથી વારસામાં મેળવો",
    nextProcessMandatoryYes: "હા, ફરજિયાત",
    nextProcessMandatoryNo: "ના, વૈકલ્પિક",
    nextProcessListRequired: "આગળ મોકલો ફરજિયાત હોય ત્યારે ઓછામાં ઓછી એક આગળની પ્રોસેસ પસંદ કરો.",
    descriptionLabel: "વર્ણન",
    descriptionPlaceholder: "સબ પ્રોસેસ વર્ણન દાખલ કરો",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    inUseError: "સબ પ્રોસેસ વપરાશમાં છે, હટાવી શકાતું નથી. કૃપા કરીને પહેલા સંબંધિત રેકોર્ડ્સ દૂર કરો.",
  },
  processRates: {
    pageTitle: "દર કાર્ડ",
    inHousePageTitle: "ઇન-હાઉસ દર",
    noProcessesAssigned: "આ પાર્ટીને હજુ કોઈ પ્રોસેસ સોંપેલ નથી.",
    noRows: "હજુ કોઈ દર ઉમેરાયો નથી.",
    subProcessLabel: "સબ પ્રોસેસ",
    itemLabel: "આઇટમ",
    allSubProcesses: "બધી સબ પ્રોસેસ",
    allItems: "બધી આઇટમ",
    rateLabel: "દર",
    rateRequired: "કૃપા કરીને માન્ય દર દાખલ કરો.",
    addRow: "દર ઉમેરો",
    save: "સાચવો",
    saving: "સાચવી રહ્યા છીએ...",
  },
  processDefinitions: {
    pageTitle: "પ્રોસેસ",
    breadcrumbHome: "હોમ",
    breadcrumbList: "પ્રોસેસ",
    addNewProcess: "નવી પ્રોસેસ ઉમેરો",
    formTitle: "પ્રોસેસ માહિતી",
    editingPrefix: "સંપાદન:",
    slugLabel: "સ્લગ",
    slugPlaceholder: "દા.ત. vmc",
    slugImmutableHint: "પ્રોસેસ બન્યા પછી સ્લગ બદલી શકાશે નહીં.",
    slugInvalid: "સ્લગમાં ફક્ત અક્ષરો, નંબર, ડેશ અને અન્ડરસ્કોર જ હોઈ શકે.",
    nameLabel: "નામ",
    namePlaceholder: "પ્રોસેસ નામ દાખલ કરો",
    nameRequired: "નામ જરૂરી છે",
    nameGuLabel: "નામ (ગુજરાતી)",
    nameGuPlaceholder: "ગુજરાતી નામ દાખલ કરો (વૈકલ્પિક)",
    rateBasisLabel: "રેટ બેસિસ",
    rateBasisPlaceholder: "રેટ બેસિસ પસંદ કરો",
    rateBasisRequired: "કૃપા કરીને માન્ય રેટ બેસિસ પસંદ કરો",
    rateBasisPiece: "પીસ",
    rateBasisWeight: "વજન",
    rateBasisSize: "સાઈઝ",
    sortOrderLabel: "ક્રમ",
    sortOrderPlaceholder: "અંતે ઉમેરવા ખાલી રાખો",
    isActiveLabel: "સક્રિય (ડેશબોર્ડ પર બતાવો)",
    hasOrderLabel: "ઓર્ડર છે",
    hasReceiveLabel: "રિસીવ છે",
    modePolicyLabel: "મોડ પોલિસી",
    modePolicyPlaceholder: "મોડ પોલિસી પસંદ કરો",
    modePolicyRequired: "કૃપા કરીને મોડ પોલિસી પસંદ કરો",
    modePolicyInHouse: "ફક્ત ઇન-હાઉસ",
    modePolicyOutsource: "ફક્ત આઉટસોર્સ",
    modePolicyBoth: "બંને (ડિફોલ્ટ ઇન-હાઉસ)",
    nextProcessLabel: "આગળ મોકલો",
    nextProcessPlaceholder: "માન્ય આગળની પ્રોસેસ પસંદ કરો",
    nextProcessHint: "કોઈપણ સક્રિય પ્રોસેસમાં મોકલવાની મંજૂરી આપવા ખાલી રાખો.",
    nextProcessMandatoryLabel: "રિસીવ સમયે આગળ મોકલો ફરજિયાત",
    nextProcessListRequired: "આગળ મોકલો ફરજિયાત હોય ત્યારે ઓછામાં ઓછી એક આગળની પ્રોસેસ પસંદ કરો.",
    cancelButton: "રદ કરો",
    saveButton: "સેવ કરો",
    saving: "સેવ થાય છે...",
    loading: "લોડ થાય છે...",
    noRecords: "કોઈ પ્રોસેસ મળી નથી",
    hasOrderBadge: "ઓર્ડર",
    hasReceiveBadge: "રિસીવ",
    activeBadge: "સક્રિય",
    inactiveBadge: "નિષ્ક્રિય",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    table: {
      srNo: "ક્રમ",
      flags: "ફ્લેગ્સ",
      status: "સ્ટેટસ",
      actions: "ક્રિયાઓ",
    },
  },
  accountTypes: {
    pageTitle: "એકાઉન્ટ ટાઈપ મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbAccountTypes: "એકાઉન્ટ ટાઈપ",
    addNewAccountType: "નવો ટાઈપ ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "નામ, ફોન અથવા વર્ણન દ્વારા શોધો...",
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "એકાઉન્ટ ટાઈપ ID",
      name: "નામ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "એકાઉન્ટ ટાઈપને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "એકાઉન્ટ ટાઈપની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    table: {
      srNo: "ક્રમ",
      name: "નામ",
      phone: "ફોન",
      totalIncome: "કુલ આવક",
      totalExpenses: "કુલ ખર્ચ",
      description: "વર્ણન",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    noRecords: "કોઈ એકાઉન્ટ ટાઈપ મળ્યો નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "એકાઉન્ટ ટાઈપ",
    formTitle: "એકાઉન્ટ ટાઈપ માહિતી",
    nameLabel: "એકાઉન્ટ ટાઈપ નામ",
    namePlaceholder: "એકાઉન્ટ ટાઈપ નામ દાખલ કરો",
    nameRequired: "એકાઉન્ટ ટાઈપ નામ આવશ્યક છે",
    phoneLabel: "ફોન નંબર",
    phonePlaceholder: "ફોન નંબર દાખલ કરો",
    descriptionLabel: "વર્ણન",
    descriptionPlaceholder: "વર્ણન દાખલ કરો",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
  },
  accounts: {
    pageTitle: "એકાઉન્ટ મેનેજમેન્ટ",
    breadcrumbHome: "હોમ",
    breadcrumbAccounts: "એકાઉન્ટ",
    addIncome: "આવક ઉમેરો",
    addExpense: "ખર્ચ ઉમેરો",
    filterToggle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "નોંધ દ્વારા શોધો...",
    fromDateLabel: "તારીખથી",
    toDateLabel: "તારીખ સુધી",
    partyLabel: "પાર્ટી",
    partyPlaceholder: "પાર્ટી પસંદ કરો",
    accountTypeLabel: "એકાઉન્ટ ટાઈપ",
    accountTypePlaceholder: "એકાઉન્ટ ટાઈપ પસંદ કરો",
    statusLabel: "સ્ટેટસ",
    statusPlaceholder: "સ્ટેટસ પસંદ કરો",
    statusOptions: {
      income: "આવક",
      expense: "ખર્ચ",
    },
    sortByLabel: "આધારે ગોઠવો",
    sortOrderLabel: "ગોઠવણીનો ક્રમ",
    sortOptions: {
      id: "એકાઉન્ટ ID",
      amount: "રકમ",
      status: "સ્ટેટસ",
      created_at: "બનાવવાની તારીખ",
    },
    sortOrderOptions: {
      asc: "નાનું થી મોટું",
      desc: "મોટું થી નાનું",
    },
    filterTitle: "ફિલ્ટર",
    sortByPlaceholder: "એકાઉન્ટને ગોઠવવા માટે વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "એકાઉન્ટની ગોઠવણીનો ક્રમ પસંદ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    generateReport: "રિપોર્ટ બનાવો",
    generateReportDateRequired: "કૃપા કરીને 'તારીખ થી' અને 'તારીખ સુધી' બંને પસંદ કરો.",
    totalIncome: "કુલ આવક",
    totalExpenses: "કુલ ખર્ચ",
    balance: "બેલેન્સ",
    table: {
      srNo: "ક્રમ",
      accountTypeParty: "એકાઉન્ટ ટાઈપ / પાર્ટી",
      status: "સ્ટેટસ",
      amount: "રકમ",
      note: "નોંધ",
      date: "તારીખ",
      actions: "ક્રિયાઓ",
    },
    income: "આવક",
    expense: "ખર્ચ",
    noRecords: "કોઈ એકાઉન્ટ મળ્યો નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "એકાઉન્ટ",
    incomeFormTitle: "આવક માહિતી",
    expenseFormTitle: "ખર્ચ માહિતી",
    accountTypeRequired: "એકાઉન્ટ ટાઈપ આવશ્યક છે",
    amountLabel: "રકમ",
    amountPlaceholder: "રકમ દાખલ કરો",
    amountRequired: "રકમ આવશ્યક છે",
    descriptionLabel: "વર્ણન",
    descriptionPlaceholder: "વર્ણન દાખલ કરો",
    saveButton: "સાચવો",
    saving: "સાચવી રહ્યું છે...",
    cancelButton: "રદ કરો",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
  },
  payments: {
    breadcrumbHome: "હોમ",
    breadcrumbParties: "પાર્ટીઓ",
    breadcrumbPayments: "પાર્ટી એકાઉન્ટ",
    pageTitle: "પાર્ટી એકાઉન્ટ વિગતો",
    summary: {
      totalInvoice: "ટોટલ હિસાબ",
      totalReceived: "ટોટલ આપેલ પેમેન્ટ",
      totalAdjustment: "ટોટલ વધ ઘટ",
      balance: "બાકી રહેતું પેમેન્ટ",
    },
    actions: {
      createInvoice: "ઈન્વોઈસ બનાવો",
      receivedPayment: "આપેલ પેમેન્ટ",
      adjustment: "એડજસ્ટમેન્ટ",
    },
    filterToggle: "ફિલ્ટર",
    filterTitle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "પેમેન્ટ શોધો...",
    fromDateLabel: "તારીખથી",
    toDateLabel: "તારીખ સુધી",
    sortByLabel: "ક્રમ",
    sortByPlaceholder: "ક્રમ પસંદ કરો",
    sortOrderLabel: "ક્રમ દિશા",
    sortOrderPlaceholder: "ક્રમ દિશા પસંદ કરો",
    sortOptions: {
      id: "પેમેન્ટ ID",
      amount: "રકમ",
      created_at: "તારીખ",
    },
    sortOrderOptions: {
      asc: "ઓછાથી વધુ",
      desc: "વધુથી ઓછા",
    },
    clearFilters: "ફિલ્ટર સાફ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    generateReport: "રિપોર્ટ બનાવો",
    generateReportDateRequired: "કૃપા કરીને 'તારીખ થી' અને 'તારીખ સુધી' બંને પસંદ કરો.",
    generateReportError: "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.",
    table: {
      srNo: "ક્રમ",
      paymentId: "એકાઉન્ટ ID",
      type: "પ્રકાર",
      details: "વિગતો",
      amount: "રકમ",
      credit: "જમા",
      debit: "ઉધાર",
      balance: "બેલેન્સ",
      date: "તારીખ",
      actions: "એક્શન બટન",
    },
    types: {
      invoice: "જમા",
      receivedPayment: "ઉધાર",
      adjustment: "એડજસ્ટમેન્ટ",
      cashPayment: "રોકડ પેમેન્ટ",
    },
    details: {
      amountAdded: "રકમ ઉમેરેલ",
      amountDeducted: "રકમ બાદ કરેલ",
    },
    sourceLabels: {
      processReceive: "પ્રોસેસ રિસીવ",
    },
    tooltips: {
      openProcessReceive: "પ્રોસેસ રિસીવ ખોલો",
    },
    sourceManaged: {
      tooltip: "આ એન્ટ્રી તેના સોર્સ મોડ્યુલ દ્વારા સંચાલિત છે. ત્યાંથી જ એડિટ અથવા ડીલીટ કરો.",
      pdfTooltip: "રિપોર્ટ ડાઉનલોડ કરો (સોર્સ મોડ્યુલ દ્વારા સંચાલિત)",
    },
    noRecords: "કોઈ પેમેન્ટ વિગતો મળી નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    pageSizeLabel: "પ્રતિ પૃષ્ઠ:",
    pageOfLabel: "પેમેન્ટ",
    deleteConfirmTitle: "શું તમે ખાતરી છો?",
    deleteConfirmText: "તમે આને પરત કરી શકશો નહીં!",
    deleteConfirmButton: "હા, કાઢી નાખો!",
    forms: {
      invoiceTitle: "ઈન્વોઈસ માહિતી",
      receivedTitle: "આપેલ પેમેન્ટ માહિતી",
      adjustmentTitle: "એડજસ્ટમેન્ટ માહિતી",
      editInvoiceTitle: "ઈન્વોઈસ માહિતી સંપાદિત કરો",
    },
    formFields: {
      status: "સ્ટેટસ",
      fromDate: "તારીખથી",
      toDate: "તારીખ સુધી",
      paymentAmount: "પેમેન્ટ રકમ",
      taxAmount: "ટેક્સ રકમ",
      roundOff: "રાઉન્ડ ઓફ",
      totalAmount: "કુલ રકમ",
      amount: "રકમ",
      note: "નોંધ",
    },
    statusOptions: {
      basedOnReceived: "મળેલ જથ્થા પર આધારિત",
      basedOnReturned: "પરત જથ્થા પર આધારિત",
    },
    adjustmentTypes: {
      extra: "વધારાનું",
      roundOff: "રાઉન્ડ ઓફ",
      taxAmount: "ટેક્સ રકમ",
      rejectedQuality: "ગુણવત્તાને કારણે નકારેલ",
      rejectedFewerPieces: "ઓછા ટુકડાને કારણે નકારેલ",
      lb: "LB",
    },
    adjustmentStatus: {
      addAmount: "રકમ ઉમેરો",
      deductAmount: "રકમ બાદ કરો",
    },
    buttons: {
      continue: "આગળ વધો",
      close: "બંધ કરો",
      saving: "સાચવી રહ્યું છે...",
    },
    pendingPayments: {
      title: "બાકી પેમેન્ટ",
      fromDate: "તારીખથી",
      toDate: "તારીખ સુધી",
      noRecords: "કોઈ બાકી પેમેન્ટ વિગતો મળી નથી",
    },
    pdfButton: "PDF",
  },
  notFound: {
    title: "પેજ મળ્યું નથી (404)",
    description: "માફ કરશો, તમે જે પેજ શોધી રહ્યા છો તે અમારી વેબસાઈટ પર ઉપલબ્ધ નથી. કદાચ તમે દાખલ કરેલ URL ખોટું છે અથવા તે પેજ અમે દૂર કર્યું છે.",
    goToMain: "મુખ્ય પેજ પર જાઓ: અમારી વેબસાઈટના મુખ્ય પેજ પર જવા માટે",
    clickHere: "અહીં ક્લિક કરો.",
  },
  stock: {
    breadcrumbHome: "હોમ",
    navSizes: "મટીરીયલ સ્ટોક",
    navItems: "આઇટમ સ્ટોક",
    navWipParties: "પાર્ટી ઓર્ડર સ્ટોક",
    navPieces: "પાઇપ પીસ સ્ટોક",
    navProcessItems: "પ્રોસેસ આઇટમ સ્ટોક",
    navProcessParties: "પ્રોસેસ પાર્ટી સ્ટોક",
    sizesPageTitle: "મટીરીયલ સ્ટોક",
    itemsPageTitle: "આઇટમ સ્ટોક",
    wipPageTitle: "પાર્ટી ઓર્ડર સ્ટોક",
    piecesPageTitle: "પાઇપ પીસ સ્ટોક",
    processItemsPageTitle: "પ્રોસેસ આઇટમ સ્ટોક",
    processPartyPageTitle: "પ્રોસેસ પાર્ટી સ્ટોક",
    sizeLabel: "મટીરીયલ",
    itemLabel: "આઇટમ",
    itemSizeLabel: "આઇટમ સાઈઝ",
    partyLabel: "પાર્ટી",
    pipeSizeLabel: "પાઇપ સાઈઝ",
    stageLabel: "સ્ટેજ",
    statusLabel: "સ્ટેટસ",
    processLabel: "પ્રોસેસ",
    qtyInLabel: "મળેલ",
    qtyOutLabel: "મોકલેલ",
    qtySentLabel: "મોકલેલ",
    qtyReceivedLabel: "મળેલ",
    stockLabel: "સ્ટોક",
    wipColLabel: "WIP",
    remainingInchesLabel: "બાકી",
    initialInchesLabel: "મૂળ",
    sourceOrderLabel: "ઓર્ડર",
    orderedQtyLabel: "ઓર્ડર કરેલ",
    routedQtyLabel: "આગળ મોકલેલ",
    availableQtyLabel: "ઉપલબ્ધ",
    pendingQtyLabel: "બાકી",
    totalIn: "કુલ ઈન",
    totalOut: "કુલ આઉટ",
    totalStock: "કુલ સ્ટોક",
    totalPiecesLabel: "કુલ પીસ",
    totalSizeLabel: "કુલ",
    selectSize: "મટીરીયલ પસંદ કરો",
    selectItem: "આઇટમ પસંદ કરો",
    selectItemSize: "આઇટમ સાઈઝ પસંદ કરો",
    selectParty: "પાર્ટી પસંદ કરો",
    selectStatus: "સ્ટેટસ પસંદ કરો",
    selectProcess: "પ્રોસેસ પસંદ કરો",
    selectPipeSize: "પાઇપ સાઈઝ પસંદ કરો",
    stageAll: "બધા સ્ટેજ",
    stageCuttingCompleted: "કટીંગ પૂર્ણ",
    stageTurningCompleted: "ટર્નિંગ પૂર્ણ",
    stageBuffingCompleted: "બફિંગ પૂર્ણ",
    stagePlattingCompleted: "પ્લેટિંગ પૂર્ણ",
    processAll: "બધા પ્રોસેસ",
    processCutting: "કટીંગ",
    processTurning: "ટર્નિંગ",
    processBuffing: "બફિંગ",
    processPlatting: "પ્લેટિંગ",
    sortByLabel: "આના દ્વારા ગોઠવો",
    sortOrderLabel: "ગોઠવણી ક્રમ",
    sortBy: {
      sizeName: "મટીરીયલ નામ",
      itemName: "આઇટમ નામ",
      stage: "સ્ટેજ",
      qtyIn: "મળેલ જથ્થો",
      qtyOut: "મોકલેલ જથ્થો",
      qtySent: "મોકલેલ જથ્થો",
      qtyReceived: "મળેલ જથ્થો",
      stock: "સ્ટોક",
      wip: "WIP",
      party: "પાર્ટી",
      partyName: "પાર્ટી નામ",
      pipeSizeName: "પાઇપ સાઈઝ",
      remainingInches: "બાકી",
      initialInches: "મૂળ",
      orderedQty: "ઓર્ડર જથ્થો",
      routedQty: "આગળ મોકલેલ જથ્થો",
      availableQty: "ઉપલબ્ધ જથ્થો",
      pendingQty: "બાકી જથ્થો",
    },
    sortOrderOptions: {
      asc: "નાનાથી મોટું",
      desc: "મોટાથી નાનું",
    },
    searchLabel: "શોધો",
    searchPlaceholder: "સાઈઝ નામ થી શોધો...",
    filterToggle: "ફિલ્ટર",
    exportReport: "રિપોર્ટ એક્સપોર્ટ કરો",
    filterTitle: "ફિલ્ટર",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    clearFilters: "ફિલ્ટર સાફ કરો",
    loading: "લોડ થઈ રહ્યું છે...",
    noRecords: "કોઈ સ્ટોક રેકોર્ડ્સ મળ્યાં નથી",
    pageSizeLabel: "પ્રતિ પેજ:",
    pageOfLabel: "રેકોર્ડ્સ",
    table: {
      srNo: "ક્રમ",
      actions: "ક્રિયાઓ",
    },
  },
  processOrders: {
    pageTitle: "પ્રોસેસ ઓર્ડર",
    breadcrumbHome: "હોમ",
    breadcrumbList: "પ્રોસેસ ઓર્ડર",
    addTitle: "નવો પ્રોસેસ ઓર્ડર",
    editTitle: "પ્રોસેસ ઓર્ડર સુધારો",
    viewTitle: "પ્રોસેસ ઓર્ડર વિગતો",
    addNew: "નવો ઓર્ડર ઉમેરો",
    modeLabel: "મોડ",
    modeInHouse: "ઇન-હાઉસ",
    modeOutsource: "આઉટસોર્સ",
    modeLockedHint: "આ પ્રોસેસ આઉટસોર્સ કરી શકાતી નથી.",
    modeLockedOutsourceHint: "આ પ્રોસેસ ફક્ત આઉટસોર્સ જ કરી શકાય છે.",
    modeLockedBySubProcess: "પસંદ કરેલ સબ પ્રોસેસ દ્વારા લોક કરેલ.",
    subProcessModeConflict: "પસંદ કરેલ સબ પ્રોસેસ ઇન-હાઉસ કે આઉટસોર્સ પર સહમત નથી — સેવ કરતા પહેલા એક દૂર કરો.",
    partyLabel: "પાર્ટી",
    partyRequiredOutsource: "આઉટસોર્સ કામ માટે કૃપા કરીને પાર્ટી પસંદ કરો.",
    selectParty: "પાર્ટી પસંદ કરો",
    dateLabel: "તારીખ",
    dateRequired: "તારીખ દાખલ કરો",
    itemsLabel: "આઈટમ્સ",
    addItem: "આઈટમ ઉમેરો",
    subProcessLabel: "સબ-પ્રોસેસ",
    selectSubProcess: "સબ-પ્રોસેસ પસંદ કરો",
    itemLabel: "આઈટમ",
    selectItem: "આઈટમ પસંદ કરો",
    itemRequired: "આઈટમ પસંદ કરો",
    rawMaterialLabel: "કાચો માલ",
    selectRawMaterial: "કાચો માલ પસંદ કરો",
    rawMaterialRequired: "કાચો માલ પસંદ કરવો જરૂરી છે",
    rawMaterialSizeLabel: "કાચા માલની સાઈઝ",
    selectRawMaterialSize: "કાચા માલની સાઈઝ પસંદ કરો",
    materialLabel: "મટીરીયલ",
    selectMaterial: "મટીરીયલ પસંદ કરો",
    selectMaterialFirst: "પહેલા મટીરીયલ પસંદ કરો",
    itemSizeLabel: "આઈટમ સાઈઝ",
    selectItemSize: "આઈટમ સાઈઝ પસંદ કરો",
    itemSizeRequired: "આઈટમ સાઈઝ પસંદ કરો",
    cuttingSizeLabel: "કટિંગ સાઈઝ",
    cuttingSizePlaceholder: "કટિંગ સાઈઝ દાખલ કરો",
    cuttingSizeRequired: "કૃપા કરીને કટિંગ સાઈઝ દાખલ કરો",
    sizeLabel: "સાઈઝ",
    selectSize: "સાઈઝ પસંદ કરો",
    weightLabel: "વજન",
    weightRequired: "વજન દાખલ કરો",
    typeLabel: "પ્રકાર",
    selectType: "પ્રકાર પસંદ કરો",
    typeAluminium: "એલ્યુમિનિયમ",
    typeWhiteMetal: "વ્હાઇટ મેટલ",
    typeRequired: "કૃપા કરીને પ્રકાર પસંદ કરો",
    qtyLabel: "જથ્થો",
    qtyRequired: "જથ્થો દાખલ કરો",
    materialSizeLabel: "મટીરીયલ સાઈઝ",
    selectMaterialSize: "મટીરીયલ સાઈઝ",
    materialSizeRequired: "મટીરીયલ સાઈઝ પસંદ કરો",
    selectItemFirst: "પહેલા આઈટમ પસંદ કરો",
    itemNoMaterialAssigned: "આ આઈટમમાં કોઈ મટીરીયલ સેટ નથી. કૃપા કરીને પહેલા મટીરીયલ માસ્ટરમાં સેટ કરો.",
    materialGroupTitle: "મટીરીયલ ગ્રુપ - પાઈપ ગણતરી",
    materialGroupDescription: "દરેક મટીરીયલ સાઈઝ માટે અંદાજિત પાઈપ વપરાશ",
    itemsCount: "આઈટમ",
    totalPipesNeeded: "કુલ પાઈપ જરૂરિયાત",
    leftoverLabel: "બાકી રહેલ",
    fromLeftover: "બાકીમાંથી: {n} નંગ",
    newPipes: "નવી પાઈપ: {n}",
    noNewPipesNeeded: "નવી પાઈપ જરૂર નથી",
    savedPiecesLabel: "સેવ થશે ({n} પીસ)",
    availableLeftoverPipes: "ઉપલબ્ધ બાકી પાઈપ (આ મટીરીયલ સાઈઝ માટે)",
    leftoverFromPreviousOrder: "અગાઉના ઓર્ડરથી બાકી:",
    nangUnit: "નંગ",
    materialDetailsTitle: "મટીરીયલ ની માહિતી",
    cancelButton: "રદ કરો",
    saveButton: "સેવ કરો",
    saveButtonLabel: "ઓર્ડર ઉમેરો",
    editButtonLabel: "ઓર્ડર અપડેટ કરો",
    saving: "સેવ થઈ રહ્યું છે...",
    filterToggle: "ફિલ્ટર",
    filterTitle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "પાર્ટી નામ...",
    fromDateLabel: "તારીખ થી",
    toDateLabel: "તારીખ સુધી",
    clearFilters: "ફિલ્ટર સાફ કરો",
    exportReport: "રિપોર્ટ એક્સપોર્ટ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    dateRangeRequired: "કૃપા કરીને તારીખ થી અને તારીખ સુધી બંને પસંદ કરો.",
    sortByLabel: "સોર્ટ બાય",
    sortOrderLabel: "સોર્ટ ઓર્ડર",
    sortByPlaceholder: "સોર્ટ વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "સોર્ટ ઓર્ડર પસંદ કરો",
    sortOptions: { id: "ID", date: "તારીખ" },
    sortOrderOptions: { asc: "વધતા ક્રમમાં", desc: "ઘટતા ક્રમમાં" },
    viewBreadcrumb: "વિગતો",
    backToList: "પાછા જાઓ",
    exportPdf: "PDF બનાવો",
    orderId: "ઓર્ડર ID",
    totalItems: "કુલ આઈટમ્સ",
    totalQty: "કુલ જથ્થો",
    accountInfo: "એકાઉન્ટ માહિતી",
    createdAt: "બનાવ્યાની તારીખ",
    updatedAt: "છેલ્લે અપડેટ",
    loading: "લોડ થઈ રહ્યું છે...",
    noRecords: "કોઈ પ્રોસેસ ઓર્ડર મળ્યાં નથી",
    pageSizeLabel: "પ્રતિ પેજ",
    noItemsText: "કોઈ આઈટમ નથી. ઉમેરવા માટે 'આઈટમ ઉમેરો' પર ક્લિક કરો.",
    removeItem: "કાઢી નાખો",
    deleteConfirmTitle: "પ્રોસેસ ઓર્ડર ડિલીટ કરો",
    deleteConfirmText: "શું તમે ખરેખર આ ઓર્ડર ડિલીટ કરવા માંગો છો?",
    deleteConfirmButton: "ડિલીટ કરો",
    cantEditAfterReceive: "રિસીવ થઇ ગયું છે, એડિટ કરી શકાશે નહીં",
    cantDeleteAfterReceive: "રિસીવ થઇ ગયું છે, ડિલીટ કરી શકાશે નહીં",
    processNotSupported: "આ પ્રોસેસ હજુ આ સ્ક્રીન પર ઉપલબ્ધ નથી.",
    table: {
      srNo: "#",
      party: "પાર્ટી",
      date: "તારીખ",
      subProcess: "સબ-પ્રોસેસ",
      qty: "જથ્થો",
      actions: "ક્રિયાઓ",
      materialSize: "મટીરીયલ સાઈઝ",
      totalNewPipes: "કુલ નવી પાઈપ",
      usedLeftover: "વપરાયેલ બાકી પાઈપ",
      savedLeftover: "સેવ થયેલ બાકી પાઈપ",
    },
  },
  processReceives: {
    pageTitle: "પ્રોસેસ રિસીવ",
    breadcrumbHome: "હોમ",
    breadcrumbList: "પ્રોસેસ રિસીવ",
    addTitle: "રિસીવ ઉમેરો",
    editTitle: "પ્રોસેસ રિસીવ સુધારો",
    viewTitle: "પ્રોસેસ રિસીવ વિગતો",
    modeLabel: "મોડ",
    modeLockedHint: "આ પ્રોસેસ આઉટસોર્સ કરી શકાતી નથી.",
    modeLockedOutsourceHint: "આ પ્રોસેસ ફક્ત આઉટસોર્સ જ કરી શકાય છે.",
    partyLabel: "પાર્ટી",
    selectParty: "પાર્ટી પસંદ કરો",
    dateLabel: "તારીખ",
    dateRequired: "કૃપા કરીને તારીખ દાખલ કરો",
    pendingOrderItemsLabel: "પેન્ડીંગ ઓર્ડર આઈટમ્સ",
    pendingItemsHelp: "રિસીવ કરવા માટે આઈટમ પસંદ કરો, જથ્થો અને ભાવ દાખલ કરો",
    selectPartyToView: "તેમના પેન્ડીંગ આઉટસોર્સ ઓર્ડર જોવા માટે વેન્ડર પાર્ટી પસંદ કરો",
    loadingItems: "લોડ થઈ રહ્યું છે...",
    noPendingItems: "કોઈ પેન્ડીંગ ઓર્ડર નથી",
    receiveQtyLabel: "રિસીવ જથ્થો",
    rateLabel: "ભાવ",
    qtyMustNotBeNegative: "જથ્થો નકારાત્મક હોઈ શકતો નથી",
    qtyRequired: "જથ્થો દાખલ કરો",
    overReceive: "વધુ રિસીવ",
    rateMustNotBeNegative: "ભાવ નકારાત્મક હોઈ શકતો નથી",
    rateRequired: "ભાવ દાખલ કરો",
    selectAtLeastOneItem: "ઓછામાં ઓછી એક આઈટમ પસંદ કરો.",
    saveReceiveButton: "રિસીવ સેવ કરો",
    updateReceiveButton: "રિસીવ અપડેટ કરો",
    saving: "સેવ થઈ રહ્યું છે...",
    cancelButton: "રદ કરો",
    orderLabel: "ઓર્ડર #{n}",
    itemSizeLabel: "આઈટમ સાઈઝ",
    subProcessLabel: "સબ-પ્રોસેસ",
    weightLabel: "વજન",
    orderQtyLabel: "ઓર્ડર",
    receivedQtyLabel: "રિસીવ થયેલ",
    remainingQtyLabel: "બાકી",
    closeItemLabel: "આઈટમ ક્લોઝ કરો",
    closeItemHint: "(ફરી પેન્ડીંગ યાદીમાં દેખાશે નહીં)",
    nextProcessLabel: "આગળ મોકલો",
    nextProcessPlaceholder: "આગળની પ્રોસેસ પસંદ કરો",
    nextProcessRequired: "કૃપા કરીને રિસીવ કરતા પહેલા આગળની પ્રોસેસ (આગળ મોકલો) પસંદ કરો",
    nextModeLabel: "મોડ",
    nextModePlaceholder: "ઇન-હાઉસ અથવા આઉટસોર્સ પસંદ કરો",
    nextModeRequired: "કૃપા કરીને ઇન-હાઉસ અથવા આઉટસોર્સ પસંદ કરો",
    inHouseLabel: "ઇન-હાઉસ",
    outsourceLabel: "આઉટસોર્સ",
    rateNotSetForParty: "આ પાર્ટી અને પ્રોસેસ માટે કોઈ દર સેટ નથી.",
    setRateLink: "દર સેટ કરો",
    totalComputedOnSaveHint: "સબટોટલ, ટેક્સ રકમ અને ગ્રાન્ડ ટોટલ સેવ કરતી વખતે ગણવામાં આવે છે.",
    nextPartyLabel: "વેન્ડર",
    nextPartyPlaceholder: "વેન્ડર પાર્ટી પસંદ કરો",
    nextPartyRequired: "કૃપા કરીને વેન્ડર પાર્ટી પસંદ કરો",
    partyRequired: "આઉટસોર્સ કામ માટે કૃપા કરીને પાર્ટી પસંદ કરો",
    typeLabel: "પ્રકાર",
    selectType: "પ્રકાર પસંદ કરો",
    typeAluminium: "એલ્યુમિનિયમ",
    typeWhiteMetal: "વ્હાઇટ મેટલ",
    voucherLabel: "વાઉચર નંબર",
    voucherPlaceholder: "વાઉચર નંબર",
    sizeLabel: "સાઈઝ",
    rawMaterialSizeLabel: "કાચા માલની સાઈઝ",
    pipeSizeLabel: "પાઈપ સાઈઝ",
    subtotalLabel: "સબ ટોટલ",
    discountLabel: "ડિસ્કાઉન્ટ",
    taxRateLabel: "ટેક્સ દર %",
    taxAmountLabel: "ટેક્સ રકમ",
    roundOffLabel: "રાઉન્ડ ઓફ",
    grandTotal: "કુલ રકમ",
    cantEditMessage: "આ રિસીવ ની આઈટમ પછીથી ફરી રિસીવ થઇ છે, એડિટ કરી શકાશે નહીં.",
    notFound: "રિસીવ ની વિગતો મળી નથી",
    totalQty: "કુલ જથ્થો",
    totalAmount: "કુલ રકમ",
    partyInfoTitle: "પાર્ટી માહિતી",
    itemsInfoTitle: "આઈટમ માહિતી",
    accountInfoTitle: "એકાઉન્ટ માહિતી",
    lastUpdated: "છેલ્લે અપડેટ",
    createdAt: "બનાવ્યાની તારીખ",
    deleteConfirmText: "શું તમે ખરેખર આ રિસીવ ડિલીટ કરવા માંગો છો?",
    deleteConfirmTitle: "પ્રોસેસ રિસીવ ડિલીટ કરો",
    deleteConfirmButton: "ડિલીટ કરો",
    calculationPrefix: "ગણતરી:",
    itemLabel: "આઈટમ",
    addReceiveButton: "રિસીવ ઉમેરો",
    receiveIdLabel: "રિસીવ ID",
    filterToggle: "ફિલ્ટર",
    filterTitle: "ફિલ્ટર",
    searchLabel: "શોધો",
    searchPlaceholder: "શોધો...",
    fromDateLabel: "તારીખ થી",
    toDateLabel: "તારીખ સુધી",
    sortByLabel: "સોર્ટ બાય",
    sortOrderLabel: "સોર્ટ ઓર્ડર",
    sortByPlaceholder: "સોર્ટ વિકલ્પ પસંદ કરો",
    sortOrderPlaceholder: "સોર્ટ ઓર્ડર પસંદ કરો",
    clearFilters: "સાફ કરો",
    applyFilters: "ફિલ્ટર લાગુ કરો",
    exportReport: "રિપોર્ટ એક્સપોર્ટ કરો",
    pageSizeLabel: "પ્રતિ પેજ",
    loading: "લોડ થઈ રહ્યું છે...",
    noReceivesFound: "કોઈ રિસીવ મળ્યાં નથી",
    cantDeleteAfterReceive: "આઈટમ ફરી રિસીવ થઇ છે, ડિલીટ કરી શકાશે નહીં",
    cantEditAfterReceive: "આઈટમ ફરી રિસીવ થઇ છે, એડિટ કરી શકાશે નહીં",
    sortOptions: { id: "ID", date: "તારીખ", grandTotal: "કુલ રકમ" },
    sortOrderOptions: { asc: "વધતા ક્રમમાં", desc: "ઘટતા ક્રમમાં" },
    dateRangeRequired: "કૃપા કરીને તારીખ થી અને તારીખ સુધી બંને પસંદ કરો.",
    processNotSupported: "આ પ્રોસેસ હજુ આ સ્ક્રીન પર ઉપલબ્ધ નથી.",
    viewBreadcrumb: "વિગતો",
    backToList: "પાછા જાઓ",
    downloadPdf: "રિપોર્ટ બનાવો",
    editReceive: "એડિટ કરો",
    amountLabel: "રકમ",
    grandTotalLabel: "કુલ રકમ",
    table: {
      srNo: "#",
      party: "પાર્ટી",
      date: "તારીખ",
      totalQty: "કુલ જથ્થો",
      grandTotal: "કુલ રકમ",
      actions: "ક્રિયાઓ",
    },
    viewTable: {
      sr: "ક્રમ",
      item: "આઈટમ",
      itemSize: "આઈટમ સાઈઝ",
      subProcess: "સબ-પ્રોસેસ",
      rawMaterial: "કાચો માલ",
      qty: "જથ્થો",
      rate: "ભાવ",
      amount: "રકમ",
    },
  },
}
